import { PayloadAction } from '@reduxjs/toolkit';
import { ItemsData } from './types';
import { initialState } from './index';

export const reducers = {
  getItems(state, action: PayloadAction<any>) {
    state.isLoading = true;
  },
  getItemsSuccess(state, action: PayloadAction<ItemsData>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  getItemsFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
